export default "__VITE_ASSET__e12e886d__"